/**
 * The maximum allowed width to give the aligned dropdown
 */
export const MAXIMUM_DROPDOWN_WIDTH = 342; /* px */

/**
 * The minimum allowed width to give the aligned dropdown
 */
export const MINIMUM_DROPDOWN_WIDTH = 288; /* px */
